import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AttendanceViewComponent } from './attendance-view/attendance-view.component';
import { LoginComponent } from './login/login.component';
import { SharedService } from './shared.service';
import { HttpClientModule } from '@angular/common/http'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EmployeeComponent } from './employee/employee.component';
import { AddEditEmployeeComponent } from './employee/add-edit-employee/add-edit-employee.component';
import { AddEditAttendanceComponent } from './attendance-view/add-edit-attendance/add-edit-attendance.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AttendanceSummaryComponent } from './attendance-summary/attendance-summary.component'
import { CommonModule, DatePipe } from '@angular/common';
import { AttendanceSummaryEditComponent } from './attendance-summary/attendance-summary-edit/attendance-summary-edit.component';
import { CalculateLeavesComponent } from './attendance-summary/calculate-leaves/calculate-leaves.component';
import { UploadAttendanceComponent } from './upload-attendance/upload-attendance.component';
import { LeaveSummaryComponent } from './attendance-summary/leave-summary/leave-summary.component';
import { ReportComponent } from './report/report.component';
import { EncashComponent } from './report/encash/encash.component';
import { DataTablesModule } from "angular-datatables"
import { EmployeeViewComponent } from './employee-view/employee-view.component';
// Import ng-circle-progress
import { NgCircleProgressModule } from 'ng-circle-progress';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { FirebaseService } from './services/firebase.service';
import { EmployeeViewReportComponent } from './employee-view/employee-view-report/employee-view-report.component';
import { EmployeeViewEditComponent } from './employee-view/employee-view-edit/employee-view-edit.component';
import { EmployeeViewRequestComponent } from './employee-view/employee-view-request/employee-view-request.component';
import { ChangeRequestComponent } from './change-request/change-request.component';
import { AppConfigService } from './app-config.service';
export function initializeApp(appConfigService: AppConfigService) {
  return (): Promise<any> => {
    return appConfigService.load();
  }
}
const firebaseConfig = {
  // apiKey: "AIzaSyAOF-PPflP48IRcdjKj9V8MwZAP5o5bx4M",
  // authDomain: "aals-app.firebaseapp.com",
  // projectId: "aals-app",
  // storageBucket: "aals-app.appspot.com",
  // messagingSenderId: "644617015686",
  // appId: "1:644617015686:web:152597c07f9564c9c49c07",
  // measurementId: "G-K36HJZ5HSN"
  apiKey: "AIzaSyBq3oT66Gxf0-jCwYQkXUVtm6o2SNf8hCI",
  authDomain: "aals-d7407.firebaseapp.com",
  projectId: "aals-d7407",
  storageBucket: "aals-d7407.appspot.com",
  messagingSenderId: "195010049332",
  appId: "1:195010049332:web:410a675304786fd828e161",
  measurementId: "G-XNNTVSCDTR"
};
@NgModule({
  declarations: [
    AppComponent,
    AttendanceViewComponent,
    LoginComponent,
    EmployeeComponent,
    AddEditEmployeeComponent,
    AddEditAttendanceComponent,
    AttendanceSummaryComponent,
    AttendanceSummaryEditComponent,
    CalculateLeavesComponent,
    UploadAttendanceComponent,
    LeaveSummaryComponent,
    ReportComponent,
    EncashComponent,
    EmployeeViewComponent,
    EmployeeViewReportComponent,
    EmployeeViewEditComponent,
    EmployeeViewRequestComponent,
    ChangeRequestComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFireAuthModule,
    AngularFireModule.initializeApp(firebaseConfig),
    NgbModule,
    DataTablesModule,
    // Specify ng-circle-progress as an import
    NgCircleProgressModule.forRoot({
      "radius": 60,
      "space": -10,
      "outerStrokeGradient": true,
      "outerStrokeWidth": 10,
      "outerStrokeColor": "#00254d",
      "outerStrokeGradientStopColor": "#53a9ff",
      "innerStrokeColor": "#f0f0f0",
      "innerStrokeWidth": 10,
      "title": "UI",
      "titleFontSize": "30",
      "titleFontWeight": "800",
      "animateTitle": false,
      "animationDuration": 350,
      "showSubtitle": false,
      "showUnits": false,
      "showBackground": false,
      "clockwise": true,
      "startFromZero": false,
      "lazy": true
    })
  ],
  providers: [
    AppConfigService,
    { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [AppConfigService], multi: true },
    SharedService,
    DatePipe,
    FirebaseService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
